var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgMessageUnreadActive = function SvgMessageUnreadActive(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 20 20",
    "aria-hidden": true,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.006 5C3.572 5 .012 7.935.012 11.495c0 1.561.656 2.966 1.78 4.09-.406 1.593-1.717 2.967-1.717 2.998-.063.063-.094.188-.063.281.063.094.125.125.25.125 2.061 0 3.622-.968 4.372-1.592a9.803 9.803 0 0 0 3.372.593c4.403 0 7.994-2.904 7.994-6.495C16 7.935 12.409 5 8.006 5Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 5,
    r: 4.5,
    fill: "#CD000A",
    stroke: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z",
    transform: "translate(0 4)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMessageUnreadActive);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;